export var PremiumStatusEnum;
(function (PremiumStatusEnum) {
    PremiumStatusEnum[PremiumStatusEnum["requested"] = 0] = "requested";
    PremiumStatusEnum[PremiumStatusEnum["unconfirmed"] = 1] = "unconfirmed";
    PremiumStatusEnum[PremiumStatusEnum["completed"] = 2] = "completed";
})(PremiumStatusEnum || (PremiumStatusEnum = {}));
export var PremiumServiceStatusEnum;
(function (PremiumServiceStatusEnum) {
    PremiumServiceStatusEnum[PremiumServiceStatusEnum["title"] = 0] = "title";
    PremiumServiceStatusEnum[PremiumServiceStatusEnum["body"] = 1] = "body";
    PremiumServiceStatusEnum[PremiumServiceStatusEnum["showLocation"] = 2] = "showLocation";
})(PremiumServiceStatusEnum || (PremiumServiceStatusEnum = {}));
export class StatusPremium {
}
//# sourceMappingURL=status-premium.js.map